"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var DomUtil_1 = require("./DomUtil");
var FocusIndicators_1 = require("../styles/FocusIndicators");
exports.FocusVisibleClassName = 'focus-visible';
var MakeFocusIndicatorStyles = function (color, inset) {
    if (color === void 0) { color = FocusIndicators_1.FocusBlue; }
    if (inset === void 0) { inset = false; }
    return Object.freeze({
        borderColor: color,
        boxShadow: inset ? "inset 0 0 0 1px " + color : "0 0 4px 0 " + color,
    });
};
var StandardIndicatorStyleName = TypeStyle.style({
    $nest: {
        '&:focus, & :focus': { outline: 'none', },
        '&::-moz-focus-inner, & ::-moz-focus-inner': { $unique: true, border: 'none' },
        '&.focus-visible:focus': MakeFocusIndicatorStyles(FocusIndicators_1.FocusBlue),
        '&.focus-visible :focus': MakeFocusIndicatorStyles(FocusIndicators_1.FocusBlue),
    },
});
/** @private This is an experimental component which may be broken or removed without notice.
 * If you believe you have a need for it, please contact #dev-shared-widgets so we may explore your use case together.
 */
// tslint:disable-next-line:class-name
var __UNSTABLE__INTERNAL__FocusIndicator = /** @class */ (function (_super) {
    tslib_1.__extends(__UNSTABLE__INTERNAL__FocusIndicator, _super);
    function __UNSTABLE__INTERNAL__FocusIndicator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { focusVisible: true };
        _this.handleBlur = function (e) {
            var _a, _b;
            var currentTarget = e.currentTarget;
            var focusTarget = DomUtil_1.findBlurRelatedTarget(e);
            _this.setState(function (prevState) { return ({ focusVisible: prevState.focusVisible || !currentTarget.contains(focusTarget) }); });
            (_b = (_a = _this.props.children.props).onBlurCapture) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleKeyDown = function (e) {
            var _a, _b;
            /* Nav keys we care about:
             * 9 Tab
             * 27 Esc
             * 33 PgUp
             * 34 PgDn
             * 35 End
             * 36 Home
             * 37 Left
             * 38 Up
             * 39 Right
             * 40 Down
             */
            var keyCode = e.keyCode;
            if (keyCode === /*tab*/ 9 || keyCode === /*esc*/ 27 || (keyCode >= 33 && keyCode <= 40)) {
                _this.setState({ focusVisible: true });
            }
            (_b = (_a = _this.props.children.props).onKeyDownCapture) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        _this.handleMouseDown = function (e) {
            var _a, _b;
            _this.setState({ focusVisible: !!_this.props.showForPointer });
            (_b = (_a = _this.props.children.props).onMouseDownCapture) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        };
        return _this;
    }
    __UNSTABLE__INTERNAL__FocusIndicator.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, showForPointer = _b.showForPointer, rest = tslib_1.__rest(_b, ["children", "showForPointer"]);
        return React.cloneElement(React.Children.only(children), tslib_1.__assign(tslib_1.__assign({}, rest), { className: TypeStyle.classes(children.props.className, StandardIndicatorStyleName, (_a = {},
                _a[exports.FocusVisibleClassName] = this.state.focusVisible,
                _a)), onKeyDownCapture: this.handleKeyDown, 
            // TODO does this need PointerEventWrapper to work in VizClient? ugh hope not
            onMouseDownCapture: this.handleMouseDown, onBlurCapture: this.handleBlur }));
    };
    return __UNSTABLE__INTERNAL__FocusIndicator;
}(React.PureComponent));
exports.__UNSTABLE__INTERNAL__FocusIndicator = __UNSTABLE__INTERNAL__FocusIndicator;
//# sourceMappingURL=FocusIndicator.js.map